import * as segmentio from 'rp-analytics';

const section1default = 'Naps Table';
const section1 = {
    'press-challenge': 'Press Challenge',
    'naps-table': 'Naps Table',
};

const state = {
    section1: null,
};

export default function analyticsPage() {
    const pathnameSplit = global.location.pathname.split('/');
    const tab = pathnameSplit[2];
    const newSection1 = !tab ? section1default : section1[tab];

    if (state.section1 && state.section1 === newSection1) {
        return;
    }

    state.section1 = newSection1;

    segmentio.setCommonTraits({
        [segmentio.TRAIT_SITE_SECTION]: 'Tipping',
        [segmentio.TRAIT_SITE_SUB_SECTION_1]: newSection1,
        [segmentio.TRAIT_SITE_SUB_SECTION_2]: null,
    });

    segmentio.page();
}



// WEBPACK FOOTER //
// ./src/js/analyticsPage.js